import { t } from "../core/i18n.js";
import { icon } from "./icons.js";

export function syncLandingAccount(root, user) {
  if (!root) return;
  root
    .querySelectorAll(
      '.landing-account-links .landing-login, .dayx-footer a[href="/login"]',
    )
    .forEach((link) => {
      link.hidden = !!user;
    });
  root
    .querySelectorAll(".landing-signup, [data-account-cta]")
    .forEach((link) => {
      link.dataset.accountCta ||= link.textContent.trim();
      if (!link.dataset.guestLabel) link.dataset.guestLabel = link.innerHTML;
      const state = user ? "signed-in" : "guest";
      if (link.dataset.accountState === state) return;
      link.dataset.accountState = state;
      if (user) {
        link.href = "/today";
        link.dataset.enter = "today";
        link.innerHTML = `${t("Open dashboard")}${icon("arrow")}`;
      } else {
        link.href = "/signup";
        delete link.dataset.enter;
        link.innerHTML = link.dataset.guestLabel;
      }
    });
}
